import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { PostingService } from 'app/core/services/posting.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { Subscription } from 'rxjs/Subscription';
import { BilledService } from 'app/pages/billing-general/billed/billed.service';
import { finalize } from 'rxjs/operators';
import { IDenialCategory } from 'app/core/interfaces/deposit.interface';

@Component({
  selector: 'app-denial-category',
  templateUrl: './denial-category.component.html',
  styleUrls: ['./denial-category.component.scss'],
})
export class DenialCategoryComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  denialCategoryForm: FormGroup;
  readonly maxDescriptionLength = 1000;

  constructor(
    private fb: FormBuilder,
    private postingService: PostingService,
    private sweetAlertHelper: SweetAlertHelper,
    private t2LoadingService: T2LoadingService,
    private billedService: BilledService
  ) {
    this.initForm();
  }

  ngOnInit() {}

  initForm() {
    this.denialCategoryForm = this.fb.group({
      description: ['', [Validators.required, Validators.maxLength(this.maxDescriptionLength)]],
      speedcode: ['', Validators.required],
      denialcode: ['', Validators.required],
      remarkcode: ['']
    });
  }

  get descriptionLength(): number {
    return this.denialCategoryForm && this.denialCategoryForm.get('description')
      ? this.denialCategoryForm.get('description').value.length
      : 0;
  }

  get isDescriptionOver(): boolean {
    return this.descriptionLength > this.maxDescriptionLength;
  }

  onSave() {
    this.t2LoadingService.show();
    const body = {
      description: this.denialCategoryForm.get('description').value,
      speedcode: this.denialCategoryForm.get('speedcode').value,
      denialcode: this.denialCategoryForm.get('denialcode').value,
      remarkcode: this.denialCategoryForm.get('remarkcode').value
    };
    this.postingService
        .registerDenialCategory(body)
        .pipe(
          finalize(() => {
            this.t2LoadingService.hiden();
          })
        )
        .subscribe({
          next: () => {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Success',
              text: 'Category added successfully',
              type: 'success',
            });
            this.setDenialCategories();
            this.setClosedModal();
            this.denialCategoryForm.reset();
          },
          error: (err) => {
            this.sweetAlertHelper.captureException(err);
          },
        });
  }

  private setDenialCategories() {
    this.billedService.getDenialsCategory().subscribe({
      next: (data: IDenialCategory[]) => {
        this.billedService.setDenialCategories(data);
      },
      error: (err) => {
        this.sweetAlertHelper.captureException(err);
      },
    });
  }

  setClosedModal() {
    this.postingService.setClosedModalDenialCategory(true);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/denial-category/denial-category.component.ts